var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    "detail" == _vm.dataMode
      ? _c("i", {
          staticClass: "el-icon-share hover_0",
          staticStyle: {
            cursor: "pointer",
            "font-size": "20px",
            "padding-left": "10px"
          },
          attrs: { title: "点击复制工单标题和链接[7]" },
          on: { click: _vm.shareTicket }
        })
      : _c("i", {
          staticClass: "el-icon-share hover_0",
          staticStyle: { cursor: "pointer", "font-size": "15px" },
          attrs: { title: "点击复制工单标题和链接[16]" },
          on: { click: _vm.shareTicket }
        })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-652847a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-652847a0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketShare.vue
// module id = 726
// module chunks = 75